import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path d="M19.5286 5.12528C19.7014 4.71275 19.2871 4.29823 18.8745 4.47084L2.30704 11.4016C2.12106 11.4794 2 11.6612 2 11.8628V12.1675C2 12.3739 2.12687 12.5592 2.31937 12.6337L8.84 15.16L11.3565 21.68C11.4309 21.8728 11.6163 22 11.823 22H12.1273C12.3289 22 12.5107 21.879 12.5885 21.6932L19.5286 5.12528Z" />,
  'Geolocation',
)
